<div class="form-field">
  <label [for]="id">{{ label }}</label>
  <div class="input-content">
    <mat-form-field
      appearance="outline"
      style="width: 100%"
      [class.invalid]="!!error"
    >
      <mat-select
        [id]="id"
        [name]="id"
        [placeholder]="placeholder || ''"
        [disabled]="disabled || readonly"
        [(ngModel)]="value"
        (selectionChange)="emitChange($event.value)"
        (openedChange)="$event ? emitFocus() : emitFocusOut()"
      >
        <mat-option
          *ngFor="let option of options"
          [value]="option[optionConfig.value]"
        >
          {{ option[optionConfig.label] | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
